'use client';

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/react-ui';
import clsx from 'clsx';
import { useRouter } from 'next/navigation';

import { EmptyCardMyGearIllustration } from '@/modules/players/v3/components/player-pages/dashboard/svgs/empty-card-my-gear-illustration';
import { GEAR_CARD_HEIGHT, GEAR_CARD_WIDTH } from '@/modules/players/v3/constants/gear';

type DashboardMyGearPickleballCentralPromoCardProps = {
  addGearHref: string;
  fluid?: boolean;
};

export const DashboardMyGearPickleballCentralPromoCard = ({
  addGearHref,
  fluid = false,
}: DashboardMyGearPickleballCentralPromoCardProps) => {
  const router = useRouter();

  return (
    <div
      className={clsx(
        'relative flex flex-col justify-between overflow-hidden rounded-[13px] p-4 text-white shadow-sm',
        fluid ? 'w-full' : 'shrink-0'
      )}
      style={
        fluid
          ? { height: GEAR_CARD_HEIGHT }
          : { width: GEAR_CARD_WIDTH, minHeight: GEAR_CARD_HEIGHT, height: GEAR_CARD_HEIGHT }
      }
    >
      <div className='pointer-events-none absolute inset-0 overflow-hidden rounded-[13px]'>
        <EmptyCardMyGearIllustration className='size-full' />
      </div>
      <div className='pointer-events-none absolute inset-0 bg-black/60' />
      <div className='pointer-events-none absolute left-1/2 top-1/2 flex h-[288px] w-[272px] -translate-x-1/2 -translate-y-1/2 items-end p-4'>
        <div className='h-9 w-full bg-gradient-to-b from-white/50 from-[66.121%] to-[#262626] to-[66.736%] mix-blend-multiply' />
      </div>

      <div className='relative z-[1] flex flex-1 flex-col items-center justify-center text-center'>
        <p className='text-[2.35rem] font-semibold leading-none tracking-tight'>400+</p>
        <p className='mt-2 max-w-[10rem] text-xs font-medium leading-[18px] text-white/95'>
          items waiting for you on pickleball central
        </p>
      </div>

      <Button
        variant='secondary'
        size='xs'
        className='relative z-[1] w-full !justify-center gap-0.5 border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
        onClick={() => router.push(addGearHref)}
      >
        Add gear
        <FontAwesomeIcon icon={faArrowRight} className='size-3 shrink-0 text-gray-600' />
      </Button>
    </div>
  );
};
